import { CommonModule, NgClass } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';

@Component({
  selector: 'app-water-device-list',
  templateUrl: './water-device-list.component.html',
  styleUrls: ['./water-device-list.component.scss'],
  standalone:true,
  imports:[NgClass,CommonModule,MatToolbar]
})
export class WaterDeviceListComponent implements OnInit {
  public sitesList: any = [];
  public groupList: any[];
  public emptyMsg: boolean = false;
  public hideItemsFromAssets: boolean = true;
  public shouldShow: boolean;
    @Input() tabName:any="";
    @Input() tab1:any="";
    @Input() tab2:any="";
    @Input() tab3:any="";
    @Input() tab4:any="";
  constructor() { }

  ngOnInit(): void {
  }

}
